module.exports = __webpack_public_path__ + "media/src/assets/images/booking-details/calendar-3e98dbb75c6e60ade0fab9e7888a91ab.png";